import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'EN', flag: '🇺🇸' },
  { code: 'vi', label: 'VI', flag: '🇻🇳' },
  { code: 'es', label: 'ES', flag: '🇪🇸' }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <div ref={ref} style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 999999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '5px'
    }}>
      {open && (
        <div style={{
          marginBottom: '6px',
          background: 'rgba(0,0,0,0.85)',
          backdropFilter: 'blur(20px)',
          borderRadius: '12px',
          border: '1px solid rgba(255,255,255,0.2)',
          overflow: 'hidden'
        }}>
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 16px',
                background: lang.code === i18n.language ? 'rgba(255,255,255,0.15)' : 'transparent',
                border: 'none',
                color: 'white',
                fontSize: '14px',
                cursor: 'pointer',
                width: '100%',
                whiteSpace: 'nowrap'
              }}
            >
              <span>{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        className="new-button"
        onClick={() => setOpen(!open)}
        type="button"
        aria-label="Change language"
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0.05))',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '16px',
          width: '56px',
          height: '56px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.2)',
          backdropFilter: 'blur(20px)'
        }}
      >
        <span style={{fontSize: '20px'}}>{current.flag}</span>
      </button>
      <span style={{
        fontSize: '11px',
        color: 'rgba(255,255,255,0.9)',
        fontWeight: 600,
        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
        background: 'rgba(0,0,0,0.4)',
        padding: '2px 6px',
        borderRadius: '8px',
        backdropFilter: 'blur(10px)'
      }}>{current.label}</span>
    </div>
  );
};

export default LanguageSwitcher;
